<template>
  <onboarding-plans v-model="selectedPriceId" :pricing-page-mode="pricingPageMode">
    <template v-if="subscriptionLoaded"
              #bottom="{ plans, commercialProducts, editorialProducts, terms, selectedPlanType, currentSelectOptionTitle, selectedSubscription, planPrices, editingSubscription, updatedSubscriptionPriceId }">
      <div class="tw-flex tw-justify-end tw-mt-4">
        <template v-if="!subscription">
          <button type="button" class="btn btn-primary btn-rounded"
                  :disabled="continueButtonDisabled(selectedPlanType, updatedSubscriptionPriceId, editingSubscription)"
                  @click="handleContinueButton">
            <span class="tw-flex tw-items-center tw-justify-center">
              <span
                class="tw-flex tw-items-center tw-justify-center tw-text-sm tw-font-semibold tw-mr-2">Continue</span>
              <i class="fas fa-arrow-right tw-text-sm"></i>
            </span>
          </button>

        </template>

        <template v-else-if="showReactivate">

          <button
            @click="handleReactivate"
            :disabled="reactivating"
            class="btn btn-primary btn-rounded">
            {{ reactivateConfirm ? 'Confirm reactivation' : 'Reactivate' }}
          </button>

        </template>

        <template v-else-if="showUpdate">
          <button
            @click="handleUpdate"
            class="btn btn-primary btn-rounded">
            Change Plan
          </button>
        </template>
      </div>

      <b-modal size="lg" v-model="showPaymentModal" hide-footer lazy title="Payment Method">
        <onboarding-payment-modal-v2 :select-title="currentSelectOptionTitle(selectedPlanType)"
                                     :prices="planPrices(selectedPlanType)"
                                     :agreement="terms"
                                     :selected-subscription="selectedSubscription"
                                     @success="handleSubscriptionSuccess"
                                     v-model="selectedPriceId"/>
      </b-modal>
    </template>
  </onboarding-plans>
</template>
<script>
import OnboardingPlans from "./OnboardingPlans.vue";
import OnboardingPaymentModalV2 from "./OnboardingPaymentModalV2.vue";
import {SubscriptionsApi} from "../../Api/SubscriptionsApi.js";
import {OrganizationsApi} from "../../Api/OrganizationsApi.js";

export default {
  components: {OnboardingPaymentModalV2, OnboardingPlans},

  props: {
    pricingPageMode: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      showPaymentModal: false,
      selectedPriceId: null,
      subscription: null,
      subscriptionLoaded: false,
      reactivateConfirm: false,
      reactivating: false,
    }
  },

  methods: {
    async handleReactivate() {
      if (!this.reactivateConfirm) {
        this.reactivateConfirm = true
      } else {
        try {
          this.reactivating = true
          await SubscriptionsApi.reactivateSubscription(this.subscription.id)
          window.location.reload()
        } catch (e) {
          this.showErrorToast("There was an error reactivating your subscription. Please try again later.")
        } finally {
          this.reactivating = false
        }
      }
    },

    handleUpdate() {
      window.location = this.productPriceUrl(this.selectedPriceId)
    },

    productPriceUrl(priceID) {
      return `/customers/subscriptions/new?price_id=${priceID}`
    },

    handleContinueButton() {
      if (this.selectedPriceId === "on_demand") {

        if (!this.pricingPageMode) {
          this.$emit('saved')
          OrganizationsApi.updateOnboarding({subscription_type: true})
        }

      } else {
        this.showPaymentModal = true
      }
    },

    handleSubscriptionSuccess() {
      this.showPaymentModal = false
      this.$emit('saved')
      if (this.signedIn) {
        window.location.href = "/customers/billing"
      }
    },

    continueButtonDisabled(selectedPlanType, updatedSubscriptionPriceId, editingSubscription) {
      if (selectedPlanType === null) {
        return true
      }

      // this isn't used right now, we remove the button if you already have a sub
      if (editingSubscription) {
        return !updatedSubscriptionPriceId
      }

      return false
    },
  },

  async mounted() {
    try {
      this.subscription = await SubscriptionsApi.getSubscription() // this will throw if there's no subscription
    } catch (e) {

    } finally {
      this.subscriptionLoaded = true
    }
  },

  computed: {
    showUpdate() {
      if (!this.subscription) return false;
      if (!this.selectedPriceId) return false;
      if (this.selectedPriceId === "on_demand") return false;
      return !this.subscription.canceled && this.selectedPriceId !== this.subscription.stripe_price_id
    },
    showReactivate() {
      if (!this.subscription) {
        return false
      }

      return this.subscription.canceled && this.selectedPriceId === this.subscription.stripe_price_id
    },

    signedIn() {
      return window.POC.uid
    }
  }
}
</script>
